import { render, staticRenderFns } from "./muteUsers.vue?vue&type=template&id=05374396&scoped=true&"
import script from "./muteUsers.vue?vue&type=script&lang=js&"
export * from "./muteUsers.vue?vue&type=script&lang=js&"
import style0 from "./muteUsers.vue?vue&type=style&index=0&id=05374396&ref=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05374396",
  null
  
)

export default component.exports